module.exports = __webpack_public_path__ + "img/Product-Title-m.971fe3ac.png";